const clockMinutes = (value) => {
    const match = /^(\d{1,2}):(\d{2})$/.exec(String(value || ""));
    if (!match) return null;
    const hour = Number(match[1]), minute = Number(match[2]);
    return hour >= 0 && hour < 24 && minute < 60 ? hour * 60 + minute : hour === 24 && minute === 0 ? 1440 : null;
};

export function selectCalendarContent({ regularItems = [], vacationItems = [], scheduledClassItems = [], classItems = [], view = "classes" }) {
    const sessions = classItems.filter((item) => item.type === "class_session");
    const assignments = classItems.filter((item) => item.type !== "class_session");
    const classes = scheduledClassItems.filter(item => !sessions.some(session => (session.lesson_id || session.lesson_sections?.length) && String(session.child_id) === String(item.child_id) && String(session.subject_id) === String(item.subject_id)));
    return [...regularItems, ...vacationItems, ...(view === "classes" ? [...classes, ...sessions] : assignments)];
}

export function calendarTimelineBounds({ subjects = [], dates = [], profileView = "school", classView = "all", items = [], slotMinutes = 15 }) {
    const scoped = subjects.filter((subject) => !subject.is_archived &&
        (profileView === "school" || String(subject.child_id) === String(profileView)) &&
        (classView === "all" || String(subject.subject_id ?? subject.id) === String(classView)));
    const weekdays = dates.map((day) => new Date(`${day}T12:00:00`).toLocaleDateString("en-US", { weekday: "long" }));
    const scheduled = scoped.filter((subject) => !["block", "flexible"].includes(subject.class_schedule?.mode));
    const occurring = scheduled.filter((subject) => subject.class_schedule?.days?.some((day) => weekdays.includes(day)));
    const schoolRanges = (occurring.length ? occurring : scheduled).flatMap((subject) => {
        const start = clockMinutes(subject.class_schedule?.start_time), end = clockMinutes(subject.class_schedule?.end_time);
        return start !== null && end !== null && end > start ? [{ start, end }] : [];
    });
    let start = schoolRanges.length ? Math.min(...schoolRanges.map((range) => range.start)) : 6 * 60;
    let end = schoolRanges.length ? Math.max(...schoolRanges.map((range) => range.end)) : 21 * 60;
    for (const item of items) {
        const itemStart = clockMinutes(item.time);
        if (itemStart === null || itemStart >= 1440) continue;
        const parsedEnd = clockMinutes(item.endTime);
        const itemEnd = parsedEnd !== null && parsedEnd > itemStart ? parsedEnd : itemStart + slotMinutes;
        start = Math.min(start, itemStart); end = Math.max(end, itemEnd);
    }
    return { start: Math.max(0, Math.floor(start / slotMinutes) * slotMinutes), end: Math.min(1440, Math.ceil(end / slotMinutes) * slotMinutes) };
}
